import Lang from 'lang.js';

import messages from './../messages';

const default_locale = window.default_language;
const fallback_locale = window.fallback_locale;

let trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );

export default {
    methods: {

        __(key, replacements, prefix = 'strings.') {
            let fullkey = /^[-_a-zA-Z]{2,20}\.[-_.a-zA-Z]+/.test(key) ? key : prefix + key;
            return trans.get(fullkey, replacements);
        },


    }
};